/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@material-ui/core";
import Countdown, { zeroPad } from "react-countdown";
import timeIcon from "../../../assets/timeIcon.png";
import {
  useStylesDark,
  useStylesLight,
} from "../../../Styles/ActiveAuctionCardStyles";
import ybTokenLogo from "../../../assets/tokens/yb.png";
import VoteCalculator from "./VoteCalculator";

const ActiveAuctionCard = (props) => {
  const classesLight = useStylesLight();
  const classesDark = useStylesDark();
  var [classes, setClasses] = useState(classesDark);
  const [isAuctionOver, setIsAuctionOver] = useState(false);
  const completedRef = useRef(null);

  // theme setting

  useEffect(() => {
    if (props.ctheme === "light") {
      setClasses(classesLight);
    } else {
      setClasses(classesDark);
    }
  }, [props.ctheme]);

  // Calculate the date
  let round = Math.floor(Math.floor(Date.now() / 1000) / (86400 * 14)) - 1348;
  const location = window.location.href;
  const suffix = location.split("/").pop();
  if (
    (round + 1348) * 86400 * 14 + 60 * 60 * 24 * 5 <
    Math.floor(Date.now() / 1000)
  ) {
    round++;
  }
  const calculatedDate =
    suffix === "yb"
      ? new Date(
          Math.floor(Date.now() / (60 * 60 * 24 * 7 * 1000)) *
            (60 * 60 * 24 * 7 * 1000)
        )
      : new Date((round + 1348) * 60 * 60 * 24 * 14 * 1000);
  if (suffix === "fxn") {
    round = round - 65;
  }
  if (suffix === "yb") {
    // weekly rounds with base offset for YB
    round = Math.floor(Math.floor(Date.now() / 1000) / (86400 * 7)) - 2910;
  }

  // Extract the day, month, and year from the date
  const day = calculatedDate.getDate();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[calculatedDate.getMonth()];
  const year = calculatedDate.getFullYear();

  // Function to append the ordinal suffix to the day
  function getOrdinalSuffix(number) {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  // Construct the final formatted string
  const formattedDate = `Week of ${day}${getOrdinalSuffix(
    day
  )} ${month} ${year}`;

  //countdown comp
  let date;
  if (suffix === "fxn") {
    date = new Date(
      (round + 1413) * 60 * 60 * 24 * 14 * 1000 +
        5 * 60 * 60 * 24 * 1000 -
        6 * 60 * 60 * 1000
    );
  } else if (suffix === "yb") {
    // YB: deposit deadline 24h before week boundary
    const weekStart =
      Math.floor(Date.now() / (60 * 60 * 24 * 7 * 1000)) *
      (60 * 60 * 24 * 7 * 1000);
    date = new Date(weekStart + 7 * 24 * 60 * 60 * 1000 - 24 * 60 * 60 * 1000);
  } else {
    date = new Date(
      (round + 1348) * 60 * 60 * 24 * 14 * 1000 +
        5 * 60 * 60 * 24 * 1000 -
        6 * 60 * 60 * 1000
    );
  }

  // Sync completion state after render to avoid "update while rendering" warning
  useEffect(() => {
    const completed = completedRef.current;
    if (completed !== null && completed !== isAuctionOver) {
      setIsAuctionOver(completed);
      props.onAuctionCompletion(completed);
    }
  });

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    completedRef.current = completed;
    if (completed) {
      return (
        <Typography className={classes.auctionEndedButton}>
          00:00:00:00
        </Typography>
      );
    }
    return (
      <span>
        {zeroPad(days)}:{zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
      </span>
    );
  };

  return (
    <>
      <Paper className={classes.auctionCard}>
        <Typography className={classes.cardTitle}>
          Round #{round} - Gauge Weight for {formattedDate}
        </Typography>

        <Typography className={classes.proposalText}>
          {!suffix === "yb" && (
            <p>
              Votium will try to vote for incentives optimally, giving vlCVX
              holders the best returns. Delegating to Votium is not mandatory.
              You can vote for yourself to receive incentives using the on-chain
              vote calculator below.
            </p>
          )}
          <Button
            className={classes.voteButton}
            onClick={() => {
              if (suffix === "yb") {
                window.open("https://yieldbasis.com/vote");
              } else if (suffix === "fxn") {
                window.open("https://www.convexfinance.com/vote/weights/fx");
              } else {
                window.open(
                  "https://www.convexfinance.com/vote/weights/curve"
                );
              }
            }}
          >
            Click here to view on&nbsp;
            {suffix === "yb" ? (
              <span>
                YB{" "}
                <img
                  src={ybTokenLogo}
                  alt="YB"
                  width="16"
                  height="16"
                  style={{ marginBottom: "-0.2em", borderRadius: "50%" }}
                />
              </span>
            ) : (
              <span>Convex</span>
            )}
            &nbsp;
          </Button>
          {props.proposal &&
            // vlCVXBalance is voting power (own lock and/or inbound delegated weight)
            props.vlCVXBalance > 0 &&
            suffix !== "yb" && (
              <VoteCalculator
                bribesArray={props.bribesArray}
                snapshotChoices={props.snapshotChoices}
                proposal={props.proposal}
                vlCVXBalance={props.vlCVXBalance}
                userVote={props.userVote}
                voteIsFromDelegate={props.voteIsFromDelegate}
                forwardingAddress={props.forwardingAddress}
                delegateAddress={props.delegateAddress}
                refreshDelegation={props.refreshDelegation}
                provider={props.provider}
                address={props.address}
                ctheme={props.ctheme}
                connect={props.connect}
              />
            )}
        </Typography>
        <TableContainer>
          <Table className={classes.table}>
            <TableBody>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.tableText}
                  style={{ borderBottom: "none" }}
                >
                  {isAuctionOver ? "Depositing Period Ended" : "Time Remaining"}
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.tableText}
                  style={{ borderBottom: "none" }}
                >
                  {<Countdown date={date} renderer={renderer} />}
                </TableCell>
                <TableCell align="right" style={{ borderBottom: "none" }}>
                  <img
                    src={timeIcon}
                    className={classes.timeIcon}
                    alt="time-icon"
                  ></img>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default ActiveAuctionCard;
